import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DeviceConfigurationModel} from '../../../../models/configuration/device-configuration.model';
import {PresentationFoldersConfigurationModel} from '../../../../models/configuration/presentation-folders-configuration.model';
import {WorkstationDevicesConfigurationModel} from '../../../../models/configuration/workstation-devices-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class PresentationFoldersConfigurationService {

  constructor(private http: HttpClient) { }
  getPresentationFolders(locId: string): Observable<PresentationFoldersConfigurationModel[]> {
    return this.http.get<PresentationFoldersConfigurationModel[]>(`api/folder-presentation-configuration/get-folder-presentation/${locId}`);
  }
  getPresentationFoldersFromFolderId(folderId: string): Observable<PresentationFoldersConfigurationModel[]> {
    return this.http.get<PresentationFoldersConfigurationModel[]>(`api/folder-presentation-configuration/get-folder-presentation-from-folderid/${folderId}`);
  }
  savePresentationFolders(presentationFolders: PresentationFoldersConfigurationModel): Observable<PresentationFoldersConfigurationModel> {
    return this.http.post<PresentationFoldersConfigurationModel>('api/folder-presentation-configuration/save-folder-presentation', presentationFolders);
  }
  deletePresentationFolder(presentationFolders: PresentationFoldersConfigurationModel): Observable<any> {
    return this.http.post<PresentationFoldersConfigurationModel>(`/api/folder-presentation-configuration/delete-folder-presentation`, presentationFolders);
  }

}
